import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { InboundOrderDto, OrderAttachmentDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';

import { saveAs } from 'file-saver';
import { ConciliationDto } from 'src/app/domain/models/dto/conciliation.dto';
import { ReconciliationSuccessModalComponent } from '../reconciliation-success-modal/reconciliation-success.modal.component';
import { DateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-financial-reconciliation-modal',
  templateUrl: './financial-reconciliation-modal.component.html',
  styleUrls: ['./financial-reconciliation-modal.component.scss']
})
export class FinancialReconciliationModalComponent implements OnInit {
  boobleModalData: InboundOrderDto;
  private readonly notifier: NotifierService;
  public loading: boolean;
  financialFormOutbound: FormGroup
  financialFormInbound: FormGroup;
  panelOpenState = false;
  constructor(
    private modalService: BoobleModalService,
    private fb: FormBuilder,
    private readonly ordersService: OrdersService,
    notifierService: NotifierService
  ) { 
    this.notifier = notifierService;
    this.financialFormInbound = fb.group({
      bankName: [null, [Validators.required, Validators.pattern(".*\\S.*")]],
      orderNumber: [null, [Validators.required, Validators.pattern(".*\\S.*")]],
      paymentDate: [null, [Validators.required, Validators.pattern(".*\\S.*")]],
      amountReceived: [null, [Validators.required, Validators.pattern(".*\\S.*")]]
    });
    this.financialFormOutbound = fb.group({
      bankName: [null, [Validators.required, Validators.pattern(".*\\S.*")]],
      orderNumber: [null, [Validators.required, Validators.pattern(".*\\S.*")]],
      billetNumber: [null, [Validators.required, Validators.pattern(".*\\S.*")]]
    });
  }

  get financialFormInboundControl() {
    return this.financialFormInbound.controls;
  }

  get financialReconciliationInbound(): ConciliationDto {
    const financialReconciliationInbound = this.financialFormInbound.value;
    return financialReconciliationInbound;
  }

  get financialFormOutboundControl() {
    return this.financialFormOutbound.controls;
  }

  get financialReconciliationOutbound(): ConciliationDto {
    const financialReconciliationOutbound = this.financialFormOutbound.value;
    return financialReconciliationOutbound;
  }

  ngOnInit() { }

  closeModal() {
    this.modalService.dismiss(null);
  }

  downloadAttachment(orderAttachment: OrderAttachmentDto) {
    this.ordersService.downloadOrderAttachment(orderAttachment.id).subscribe({
      next: (data: any) => saveAs(data, orderAttachment.fileName),
    });
  }

  attachmentFileName(fileName: string) {
    return fileName.substring(fileName.lastIndexOf('-') + 1, fileName.length);
  }

  sendForm() {
    this.loading = true;

    let form: ConciliationDto;
    this.boobleModalData.remmitanceType == 'INBOUND' ? form = this.financialReconciliationInbound : form = this.financialReconciliationOutbound;
    this.boobleModalData.conciliation = form;

  }

}
